<app-landing-screen [backgroundImageUrl]="backgroundImageUrl">
  <section class="contents-container">
    <section class="contents">
      <section class="title">
        <h1>Unauthorised</h1>
        <p>You are not allowed to be here.</p>
        <p>Please try login again or go back home.</p>
        <section class="buttons">
          <button mat-flat-button color="primary" (click)="login()">
            Login
          </button>
          <button mat-flat-button color="primary" [routerLink]="['/']">
            Home
          </button>
        </section>
      </section>
      <br />
    </section>
  </section>
</app-landing-screen>
